'use client';
import loadBackgroudImages from '../../common/loadBackgroudImages';
import React, { useEffect } from 'react';

function Feat() {
  useEffect(() => {
    loadBackgroudImages();
  }, []);
  return (
    <section className="feat section-padding">
      <div className="container ontop">
        <div className="row">
          <div className="col-lg-5">
            <div className="cont md-mb50">
              <h6 className="sub-title main-color mb-15">Güvenilir Hizmetler</h6>
              <h3 className="mb-30">
                Sunduğumuz hizmetler ihtiyaçlarınız
                gözetilerek özel olarak tasarlanmıştır.
              </h3>
              <p>
                Yenilikçi çözümler ve sarsılmaz mükemmeliyetle kalıcı bir etki
                yaratmaya adanmış profesyonel bir ekip.
              </p>
              <a
                href="/page-about"
                className="butn-crev d-flex align-items-center mt-40"
              >
                <span className="hover-this">
                  <span className="circle hover-anim">
                    <i className="ti-arrow-top-right"></i>
                  </span>
                </span>
                <span className="text">Daha Fazla</span>
              </a>
            </div>
          </div>
          <div className="col-lg-6 offset-lg-1">
            <div className="item mb-30">
              <div className="row">
                <div
                  className="col-md-4 bg-img"
                  data-background="/assets/imgs/serv-img/1.jpg"
                ></div>
                <div className="col-md-8">
                  <div className="info">
                    <h5 className="mb-15">Web Tasarım</h5>
                    <p>
                      Markanızı yansıtan modern ve kullanıcı dostu web siteleri
                      tasarlıyoruz.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="item mb-30">
              <div className="row">
                <div
                  className="col-md-4 bg-img"
                  data-background="/assets/imgs/serv-img/2.jpg"
                ></div>
                <div className="col-md-8">
                  <div className="info">
                    <h5 className="mb-15">Marka Kimliği</h5>
                    <p>
                      Güçlü ve akılda kalıcı marka kimlikleri oluşturarak sizi
                      rakiplerinizden ayırıyoruz.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <div className="row">
                <div
                  className="col-md-4 bg-img"
                  data-background="/assets/imgs/serv-img/3.jpg"
                ></div>
                <div className="col-md-8">
                  <div className="info">
                    <h5 className="mb-15">Dijital Pazarlama</h5>
                    <p>
                      SEO, sosyal medya ve reklam stratejileriyle hedef
                      kitlenize etkili şekilde ulaşıyoruz.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="circle-blur">
        <img src="/assets/imgs/patterns/blur1.png" alt="" />
      </div>
    </section>
  );
}

export default Feat;
